/**
 * カートページ: 合計パネルを商品テーブル右カラムへ配置（Dawn の2セクション構成を維持）
 */
(function () {
  const ASIDE_ID = 'dreampiece-cart-aside';
  const FOOTER_ID = 'main-cart-footer';
  const FOOTER_SECTION_CLASS = 'cart__footer-wrapper';

  function layoutDreampieceCart() {
    const aside = document.getElementById(ASIDE_ID);
    const footer = document.getElementById(FOOTER_ID);
    if (!aside || !footer) return;

    const footerSection = document.querySelector(`.shopify-section.${FOOTER_SECTION_CLASS}`);

    if (footer.parentElement !== aside) {
      aside.appendChild(footer);
    }

    if (footerSection) {
      footerSection.hidden = true;
    }

    const cartItems = document.querySelector('cart-items.dreampiece-cart');
    if (cartItems) {
      cartItems.classList.toggle('dreampiece-cart--has-sidebar', !footer.classList.contains('is-empty'));
    }
  }

  function init() {
    layoutDreampieceCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(layoutDreampieceCart);
    });
  }
})();
